import Biblioteca from '@/components/Repositorio/Biblioteca.js'

export default {
  async buscarAcompanhamentoVendas(api, parametros) { 
    parametros.operacao = 'buscarAcompanhamentoVendas';
    let retorno = {};

    await api.santriGET('/rest/relacaoAcompanhamentoVendas', parametros, 10, true)
    .then(response => {
      retorno = Biblioteca.retornoRequisicao('N', undefined, response.data)
    })
    .catch(error => {
      retorno = Biblioteca.retornoRequisicao('S', error, undefined)
    })

    return retorno;
  }
}


// WEBPACK FOOTER //
// ./src/components/Rest/RRelacaoAcompanhamentoVendas.js